import { productCodesFilterAtom } from 'atoms/filters/sim';
import { productCodesHintsAtom } from 'atoms/hints/sim';
import { ProductCodeSearchFilter } from 'src/common/components/Filters/Inputs/productCode/ProductCodeSearchFilter';

export const ProductCodesSearchInput = () => {
  return (
    <ProductCodeSearchFilter
      productCodesFilterAtom={productCodesFilterAtom}
      productCodesHintsAtom={productCodesHintsAtom}
    />
  );
};
